import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 100%;
`;

export const SectionForm = styled.div`
  width: 30%;
  height: calc(100vh - 64px);
  background-color: var(--card-bg);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    width: 100%;
    position: relative;
  }
`;

export const Content = styled.div`
  padding: 40px 64px;
  width: 100%;
  max-width: 420px;

  @media (max-width: 1024px) {
    padding: 40px 20px;
    max-width: 100%;
  }
`;

export const FormContent = styled.form`
  padding: 24px 0;
`;

export const FormGroup = styled.div``;

export const TermDescription = styled.p`
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.01em;
  color: var(--gray-500);
  margin: 20px 0;
`;

export const PasswordRecovery = styled.a`
  font-family: var(--font-body);
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.01em;
  color: var(--gray-600);
  margin: 0 0 var(--space-6) 0;
  display: inline-block;
  text-decoration: none;
  transition: var(--transition);

  strong {
    color: var(--navy);
  }

  &:hover {
    color: var(--navy);
  }
`;

export const AccountExists = styled.a`
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.01em;
  color: var(--gray-600);
  margin: var(--space-6) 0;
  display: inline-block;
  text-decoration: none;
  text-align: center;
  width: 100%;
  transition: var(--transition);

  &:hover {
    color: var(--navy);
  }
`;

export const PageLogo = styled.img`
  width: 200px;
  margin-bottom: var(--space-8);
`;

export const PageTitle = styled.h1`
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 28px;
  line-height: 140%;
  color: var(--navy);
  margin-bottom: var(--space-2);
`;

export const PageDescription = styled.p`
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: var(--gray-500);
`;

export const SectionBanner = styled.div`
  width: 70%;
  height: calc(100vh - 64px);
  background-size: cover;
  background-position: center;
  background-image: url(${require("../../../assets/images/login/background-login-3.jpg")});

  @media (max-width: 1024px) {
    display: none;
  }
`;
